import React from 'react'
import Input from './Input'

export default function TextInput (props) {
  const css = `string ${props.className || ''}`
  return <Input {...props} className={css} type='text' />
}


